import { useState } from "react";
import Seo from "../components/Seo";
import { X } from "lucide-react";

const SFEER_2026 = [
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/ndaxk1jl_BFM-MB-Snelle%20edit--11%20%281%29_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — beachvolleybal in actie",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/h5f1cg9a_sfeerbeeld_6_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — beachvolley speler in de zon",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/9zqfu1f8_BFM-MB-Snelle%20edit--10%20%281%29_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — publiek langs de volleybalvelden",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/hnsblf5q_sfeerbeeld_7_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — fans juichen langs het veld",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/3habkngt_BFM-MB-Snelle%20edit--4%20%281%29_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — spelers vieren onder de palmboom",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/ciguae3v_sfeerbeeld_8_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — supporters in strandstoelen",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/bwi2n1bu_BFM-MB-Snelle%20edit--3%20%281%29_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — beachvolley match op het strand",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/z058p3j4_sfeerbeeld_9_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — publiek langs de afsluiting bij zonsondergang",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/sjeidd1g_BFM-MB-Snelle%20edit--2%20%281%29_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — genieten op het terras met een drankje",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/kc5gypg8_sfeerbeeld_10_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — speler serveert bij gouden avondlicht",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/ctodhh6u_extra_sfeerbeeld_1_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — DJ zorgt voor sfeer op de dansvloer",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/ytipe4xs_extra_sfeerbeeld_2_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — jongen aan de skate-ramp bij Skatehouse",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/n5j1ioj5_extra_sfeerbeeld_3_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — kind speelt ringwerpen op de kindernamiddag",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/kthbm2ok_extra_sfeerbeeld_4_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — springkastelen en terras op het strand",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/gj7unwgb_extra_sfeerbeeld_5_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — luchtbeeld van het strand tijdens de zonsondergang",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/3gvsqm77_extra_sfeerbeeld_6_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — jongen oefent stokvechten op het strand",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/7ynvl8i9_extra_sfeerbeeld_7_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — supporters juichen op ligstoelen bij Sport Vlaanderen",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/hom12qyx_extra_sfeerbeeld_8_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — Napoleon speler klaar voor de service onder de palmboom",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/xngbbfon_extra_sfeerbeeld_9_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — kinderen klimmen op het springkasteel",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/iygew9fi_extra_sfeerbeeld_10_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — jonge schaker geconcentreerd aan het bord",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/12rwpkkq_capoeira_roundnet_1_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — capoeira-optreden onder de festivaltent",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/qzbpv5ik_capoeira_roundnet_2_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — winnaars van het roundnet-tornooi met hun trofee",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/7z2tjbmt_capoeira_roundnet_3_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — podiumceremonie van het roundnet-tornooi op het strand",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/6mlcwdsv_capoeira_roundnet_4_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — roundnet spelers in actie rond het net",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/9a5lj454_capoeira_roundnet_5_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — capoeira dansers geven een dynamische demo",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/xiyflunu_capoeira_roundnet_extra_1_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — roundnet match voor de strandbar",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/h7qbugok_capoeira_roundnet_extra_2_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — roundnet speler in Chile-shirt aan de service",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/ptt85bgh_capoeira_roundnet_extra_3_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — capoeira roda met muzikanten in de tent",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/dpnwyzz8_capoeira_roundnet_extra_4_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — roundnet actie voor het publiek",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/99inmoqg_capoeira_roundnet_extra_5_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — jonge capoeirista met een hoge trap",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/1v9x20jd_night_party_1_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — Mondea-team poseert 's avonds op het beachvolleybalveld",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/5gfyo4t6_night_party_2_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — vrienden lachen samen in de festivaltent",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/gskvjtwt_night_party_3_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — dansende bezoeker met de handen in de lucht op de Rum & Bass-avond",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/7xfbdt32_night_party_4_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — twee vriendinnen genieten samen op de dansvloer",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/29v8m01k_night_party_5_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — vrienden proosten met een Cornet-glas op de feestavond",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/36lqqzkp_night_party_extra_1_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — volle festivaltent met visnetten en blauwe lichtshow tijdens een avondconcert",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/nfufrw4f_night_party_extra_2_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — DJ-booth met uitzicht op de dansende menigte in de tent",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/air2cj8x_night_party_extra_3_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — team Minze poseert 's avonds op het beachvolleybalveld",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/75bkg7io_night_party_extra_4_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — sfeerbeeld in de tent met warme lichten en gezellig publiek",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/ll132bkr_night_party_extra_5_resized.jpg",
    alt: "Sfeerbeeld Mechelen Beach 2026 — enthousiast team viert de overwinning met een Gouden Carolus onder de palmen",
  },
];

const GALLERY = [
  // Aerial overview — uploaded 2026
  {
    src: "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/moc5lvo5_Dag.jpg",
    alt: "Luchtfoto van Mechelen Beach overdag — overzicht van het terrein bij daglicht",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/9uwm9ssj_Nacht.jpg",
    alt: "Luchtfoto van Mechelen Beach 's nachts — sfeervol verlicht terrein",
  },
  // Newly uploaded — sfeerbeelden 2025
  {
    src: "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/7mugoat3_MechelenBeach_Pictures_DAY3_BlueFrame-110.jpg",
    alt: "Estaminet pint aan de bar van Mechelen Beach",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/a004196s_MechelenBeach_Day1Pictures_BlueFrame-32.jpg",
    alt: "Vriendinnen lachen tijdens een avond op Mechelen Beach",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/wczpdl5e_481986415_631598972959186_5991180656551499416_n%20%281%29.jpg",
    alt: "Zonsondergang boven het terras van Mechelen Beach",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/0nx8eetx_roundnet%20%281%29.jpg",
    alt: "Roundnet in actie op het sportstrand",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/935n4h5k_airbadminton%202024%20-%205.jpg",
    alt: "Airbadminton op het sportstrand van Mechelen Beach",
  },
  // Eerder geüploade sfeerbeelden — vrijwilligers, kinderen, volleybal
  {
    src: "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/cd3j75rl_WhatsApp%20Image%202026-06-08%20at%2003.32.11%20%282%29.jpeg",
    alt: "Vrijwilligers achter de bar tijdens een avondsessie",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/ed16ca5x_kinderstrand%20-%20boogschieten.jpg",
    alt: "Boogschieten op het Kinderstrand van Mechelen Beach",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/s4vxo7m0_WhatsApp%20Image%202026-06-08%20at%2003.32.11%20%281%29.jpeg",
    alt: "Vrijwilligers van Mechelen Beach tappen frisse drankjes",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/slo7pefx_481265216_631586586293758_7351160883865797685_n.jpg",
    alt: "Beachvolleybal in actie op Mechelen Beach",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/337w5nf5_489921185_18004258307749830_1673319246577492723_n.jpg",
    alt: "Supporters aan het juichen tijdens het toernooi",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/6bblimvm_kabouterwandeling.jpg",
    alt: "Gezinnen met kinderen tijdens een kabouterwandeling",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/4dmfhg0b_MechelenBeach_VolleyKids-73.jpg",
    alt: "Volley Kids — sport en plezier op het strand",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/ui27jm6i_502692385_695019233283826_6603976957128579495_n.jpg",
    alt: "Team Mechelen Beach met trofee onder Den Carolus parasol",
  },
];

export default function Fotos() {
  const [lightbox, setLightbox] = useState(null);

  return (
    <>
      <Seo
        title="Foto's | Mechelen Beach 2026"
        description="Bekijk sfeerbeelden van Mechelen Beach: zomerse momenten, strandbar, sport, kinderplezier en gezellige avonden op het Douaneplein."
      />

      <section className="bg-warm-gradient">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 lg:pt-24 pb-8 sm:pb-10">
          <div className="max-w-2xl">
            <span className="eyebrow">Media</span>
            <h1 className="font-display mt-5 text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-[#2b1c10] leading-[1.05]">
              Sfeerbeelden van Mechelen Beach
            </h1>
            <p className="mt-5 text-base sm:text-lg text-[#6b5945] leading-relaxed">
              Bekijk enkele sfeerbeelden van Mechelen Beach: zomerse momenten,
              strandbar, sport, kinderplezier en gezellige avonden op het
              Douaneplein.
            </p>
          </div>
        </div>
      </section>

      <section
        data-testid="fotos-sfeer-2026"
        className="bg-warm-gradient pt-4 sm:pt-6 pb-10 sm:pb-14"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-6 sm:mb-8">
            <span className="eyebrow">Editie 2026</span>
            <h2 className="font-display mt-3 text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-[#2b1c10]">
              Sfeerbeelden Mechelen Beach 2026
            </h2>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 sm:gap-4">
            {SFEER_2026.map((img, i) => (
              <button
                key={img.src}
                type="button"
                onClick={() => setLightbox(img)}
                data-testid={`foto-sfeer-2026-${i}`}
                className="group relative aspect-square rounded-xl overflow-hidden border border-[#ebd9b5] shadow-[0_10px_28px_-18px_rgba(43,28,16,0.25)] bg-white text-left transition-transform duration-300 hover:-translate-y-0.5"
              >
                <img
                  src={img.src}
                  alt={img.alt}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.06]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#2b1c10]/30 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </button>
            ))}
          </div>
        </div>
      </section>

      <section
        data-testid="fotos-gallery"
        className="bg-warm-gradient pb-16 sm:pb-20"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-6 sm:mb-8">
            <span className="eyebrow">Archief</span>
            <h2 className="font-display mt-3 text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-[#2b1c10]">
              Meer sfeerbeelden
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
            {GALLERY.map((img, i) => (
              <button
                key={img.src}
                type="button"
                onClick={() => setLightbox(img)}
                data-testid={`foto-${i}`}
                className={`group relative rounded-2xl overflow-hidden border border-[#ebd9b5] shadow-[0_14px_36px_-18px_rgba(43,28,16,0.25)] bg-white text-left transition-transform duration-300 hover:-translate-y-0.5 ${
                  i % 5 === 0 ? "sm:col-span-2 sm:row-span-2" : ""
                }`}
              >
                <img
                  src={img.src}
                  alt={img.alt}
                  loading="lazy"
                  className={`w-full object-cover transition-transform duration-700 group-hover:scale-[1.04] ${
                    i % 5 === 0 ? "h-[320px] sm:h-[560px]" : "h-[260px] sm:h-[270px]"
                  }`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#2b1c10]/30 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </button>
            ))}
          </div>
        </div>
      </section>

      {lightbox && (
        <div
          data-testid="foto-lightbox"
          className="fixed inset-0 z-50 bg-[#2b1c10]/90 backdrop-blur-sm flex items-center justify-center p-4 sm:p-8 animate-fadeup"
          onClick={() => setLightbox(null)}
          role="dialog"
          aria-modal="true"
        >
          <button
            type="button"
            onClick={() => setLightbox(null)}
            aria-label="Sluit"
            data-testid="foto-lightbox-close"
            className="absolute top-5 right-5 inline-flex h-10 w-10 items-center justify-center rounded-full bg-white text-[#2b1c10] hover:bg-[#ed6a1a] hover:text-white transition-colors"
          >
            <X className="h-5 w-5" />
          </button>
          <img
            src={lightbox.src}
            alt={lightbox.alt}
            className="max-h-[88vh] max-w-[92vw] object-contain rounded-2xl shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </>
  );
}
